






















































































import { Vue, Component, Prop } from "vue-property-decorator";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import StudentTable from "@/components/students/StudentTable.vue";
import {
  Course as ICourse,
  RegistrationCreateStatusEnum,
  RegistrationList as IRegistrationList,
  Student as IStudent,
  RegistrationStatusEnum
} from "@/api-v2/course/models";
import { courseApi } from "@/getinfo-api";
import CourseRegistrationsTable from "@/components/courses/CourseRegistrationsTable.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import CField from "@/components/form/CField.vue";
import { studentLimitModule } from "@/plugins/modules-detect";

@Component({
  components: {
    CField,
    CSingleSelect,
    CourseRegistrationsTable,
    StudentTable,
    CustomButton,
    CBlock
  }
})
export default class CourseStudentsSection extends Vue {
  @Prop() course!: ICourse;
  key: number = 0;
  isShow: boolean = false;
  registrations!: IRegistrationList;
  checkedStudents: IStudent[] = [];
  registrationForm: any = {
    status: undefined
  };
  studentForm: any = {
    name: ""
  };
  data() {
    return {
      registrations: undefined
    };
  }

  get isStudentLimitModule() {
    return studentLimitModule() && this.$store.state.studentLimit !== 0;
  }

  get isBlockAddStudent() {
    return (
      this.isStudentLimitModule &&
      this.$store.state.studentLimit - this.$store.state.studentAmount <
        this.checkedStudents.length
    );
  }

  get statusOptions() {
    return [
      {
        key: `${this.$tc(this.$translate.All)}`,
        value: undefined
      },
      {
        key: `${this.$tc(this.$translate.Learning)}`,
        value: RegistrationStatusEnum.Learning
      },
      {
        key: `${this.$tc(this.$translate.Pause)}`,
        value: RegistrationStatusEnum.Pause
      },
      {
        key: `${this.$tc(this.$translate.Success)}`,
        value: RegistrationStatusEnum.Success
      },
      {
        key: `${this.$tc(this.$translate.Failed)}`,
        value: RegistrationStatusEnum.Fail
      },
      {
        key: `${this.$tc(this.$translate.Canceled)}`,
        value: RegistrationStatusEnum.Abort
      }
    ];
  }

  async registerStudents() {
    try {
      await Promise.allSettled(
        this.checkedStudents.map(async el => {
          await courseApi.CourseRegistration.createCourseRegistration({
            studentId: el.id,
            courseId: this.course.id,
            status: "learning" as RegistrationCreateStatusEnum,
            metadata: []
          }).then(res => {
            this.$store.state.studentAmount++;
            this.registrations.items.push(res.data);
          });
        })
      );
      this.$emit("handleRegistration");
      this.key++;
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    }
  }
}
